import React from "react";
import { useFormContext } from "react-hook-form";
import css from "./style.scss";
import classNames from "classnames";

const CheckboxField = ({ 
  name, 
  label, 
  id = null,
  className = '',
  labelClassName = '',
  containerClassName = '',
  required = false 
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const fieldId = id || name;

  return (
    <div className={classNames(css.clsFormGroup, containerClassName)}>
      <input 
        type="checkbox" 
        id={fieldId}
        {...register(name)}
        className={className}
      />
      <label 
        className={classNames(
          labelClassName,
          errors[name] && css.text_danger
        )} 
        htmlFor={fieldId}
      >
        {label}
        {required ? <span className={css.text_primary}>*</span> : null}
      </label>
      {errors[name] && (
        <div className={classNames(css.clsFormErrorText, css.text_danger)}>
          {errors[name].message}
        </div>
      )}
    </div>
  );
};

export default CheckboxField;

